export const LEN_CERTIFICATE_ID = 9;

export const FABRICS_APP = "fabrics";